import { styled } from "@mui/material/styles";
import { Box, Grid } from "@mui/material";

export const Container = styled(Box)(({ theme }) => ({
  background: theme.palette.background.paper,
  borderRadius: `${theme.shape.borderRadius}px`,
  padding: "25px",
  marginTop: "15px",
}));

export const StyledGrid = styled(Grid)({
  backgroundColor: "#f5f5f5",
});
